import { render, staticRenderFns } from "./OinCardPage.vue?vue&type=template&id=0a585fc4&scoped=true&"
import script from "./OinCardPage.vue?vue&type=script&lang=js&"
export * from "./OinCardPage.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=0a585fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a585fc4",
  null
  
)

export default component.exports